import { render, staticRenderFns } from "./ViewPdffile.vue?vue&type=template&id=6e08a210&scoped=true"
import script from "./ViewPdffile.vue?vue&type=script&lang=js"
export * from "./ViewPdffile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e08a210",
  null
  
)

export default component.exports